module.exports = __webpack_public_path__ + "img/boconcept-copy.1c52a50d.png";